"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.MedicalCodeChip = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var svg_icons_1 = __importDefault(require("../svgs/svg-icons"));
var conditional_1 = require("../conditional/conditional");
var ui_common_1 = require("@codametrix/ui-common");
var EditorIssueLevel = ui_common_1.commonEnums.EditorIssueLevel;
var IconCell = function (_a) {
    var iconName = _a.iconName, iconClass = _a.iconClass;
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "qa-scrubber-issues scrubber-issues col-evidence code-indicator-cell" }, { children: (0, jsx_runtime_1.jsx)("span", __assign({ className: "indicator" }, { children: (0, jsx_runtime_1.jsx)(svg_icons_1["default"], { svgIconName: "".concat(iconName), svgIconSize: "20", svgIconClass: "".concat(iconClass) }) })) })));
};
var MedicalCodeChip = function (_a) {
    var _b;
    var code = _a.code, codeType = _a.codeType, editable = _a.editable, sequence = _a.sequence, isDraggable = _a.isDraggable, classNames = _a.classNames, handleCodeDelete = _a.handleCodeDelete, onDrop = _a.onDrop, active = _a.active, shared = _a.shared, isSharedInvoice = _a.isSharedInvoice, handleCodeChecked = _a.handleCodeChecked, codeEdits = _a.codeEdits;
    /**
     * State to track if the item is currently being dragged.
     */
    var _c = __read((0, react_1.useState)(false), 2), isDragging = _c[0], setIsDragging = _c[1];
    /**
     * State to track the hover position (either 'left' or 'right') during drag.
     */
    var _d = __read((0, react_1.useState)(null), 2), dragOverPosition = _d[0], setDragOverPosition = _d[1];
    /**
     * Handler for drag start event, setting up the drag data and effect.
     */
    var handleDragStart = function (e) {
        e.dataTransfer.setData('text/plain', sequence.toString());
        e.dataTransfer.effectAllowed = 'move';
        setIsDragging(true);
    };
    /**
     * Handler for the drop event, calling the onDrop callback to reorder items.
     */
    var handleDrop = function (e) {
        var dragIndex = Number(e.dataTransfer.getData('text/plain'));
        onDrop(dragIndex, sequence);
        setDragOverPosition(null);
    };
    /**
     *  Handler for when the item is dragged over a valid drop target.
     */
    var handleDragOver = function (e) {
        e.preventDefault();
        // Calculate the hover position (left or right) based on the mouse's X position.
        var _a = e.currentTarget.getBoundingClientRect(), left = _a.left, width = _a.width;
        var mouseX = e.clientX;
        setDragOverPosition(mouseX < left + width / 2 ? 'left' : 'right');
        e.dataTransfer.dropEffect = 'move';
        setIsDragging(false);
    };
    /**
     * Handler for when the dragged item leaves the target area.
     */
    var handleDragLeave = function () {
        setDragOverPosition(null); // Clear the hover position when dragging leaves.
    };
    var onCodeDelete = function (e) {
        e.preventDefault();
        handleCodeDelete(e);
    };
    var _classNames = classNames.join(' ');
    // change icon here... turned off for now.
    var iconName = active ? 'BiomeCheckSVG20' : 'BiomeMinusSVG20';
    var allEdits = (_b = codeEdits === null || codeEdits === void 0 ? void 0 : codeEdits[code]) !== null && _b !== void 0 ? _b : [];
    var vwErrors = allEdits.some(function (edit) { return edit.level === EditorIssueLevel.ERROR; });
    var vwWarnings = allEdits.some(function (edit) { return edit.level === EditorIssueLevel.WARNING; });
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "medical-code-chip ".concat(isDragging ? 'dragging' : '', " ").concat(isDraggable ? 'isDraggable' : '', " ").concat(codeType, " ").concat(shared ? 'transaction-shared-code' : '', " ").concat(_classNames), draggable: isDraggable, onDragStart: handleDragStart, onDrop: handleDrop, onDragOver: handleDragOver, onDragLeave: handleDragLeave }, { 'data-code': code, 'data-code-type': codeType }, { children: [dragOverPosition && ((0, jsx_runtime_1.jsx)("div", { className: "drop-indicator ".concat(dragOverPosition, " ").concat(codeType) })), shared && !isSharedInvoice ? ((0, jsx_runtime_1.jsx)("label", { children: (0, jsx_runtime_1.jsx)("span", __assign({ className: "icd-shared-code unclickable prevent-click", "data-dd-action-name": active ? '~Toggle code off' : '~Toggle code on' }, { children: (0, jsx_runtime_1.jsxs)("span", __assign({ className: "chip ".concat(codeType, " shared ").concat(active ? 'on' : 'off', " ").concat(isDragging ? 'dragging' : '', " ").concat(vwErrors
                            ? 'vwError'
                            : vwWarnings && !vwErrors
                                ? 'vwWarning'
                                : '') }, { children: [(0, jsx_runtime_1.jsx)(conditional_1.Conditional, __assign({ on: vwErrors }, { children: (0, jsx_runtime_1.jsx)(IconCell, { iconName: "BiomeVWErrorSVG20", iconClass: "qa-issue-error alert-error" }) })), (0, jsx_runtime_1.jsx)(conditional_1.Conditional, __assign({ on: !vwErrors && vwWarnings }, { children: (0, jsx_runtime_1.jsx)(IconCell, { iconName: "BiomeVWWarningSVG20", iconClass: "qa-issue-warning alert-warning" }) })), (0, jsx_runtime_1.jsx)("input", { type: "checkbox", style: { display: 'none' }, name: "".concat(code), onClick: handleCodeChecked, className: "txn-shared-checkbox", defaultChecked: active, disabled: !editable }), active && ((0, jsx_runtime_1.jsx)(svg_icons_1["default"], { svgIconName: iconName, svgIconSize: "12", svgIconClass: "shared-icon" })), (0, jsx_runtime_1.jsx)("span", __assign({ className: "code-text" }, { children: code }))] })) })) })) : ((0, jsx_runtime_1.jsxs)("span", __assign({ className: "chip ".concat(codeType, " ").concat(isDragging ? 'dragging' : '', " ").concat(vwErrors ? 'vwError' : vwWarnings && !vwErrors ? 'vwWarning' : '') }, { children: [(0, jsx_runtime_1.jsx)(conditional_1.Conditional, __assign({ on: vwErrors }, { children: (0, jsx_runtime_1.jsx)(IconCell, { iconName: "BiomeVWErrorSVG20", iconClass: "qa-issue-error alert-error" }) })), (0, jsx_runtime_1.jsx)(conditional_1.Conditional, __assign({ on: !vwErrors && vwWarnings }, { children: (0, jsx_runtime_1.jsx)(IconCell, { iconName: "BiomeVWWarningSVG20", iconClass: "qa-issue-warning alert-warning" }) })), (0, jsx_runtime_1.jsx)("span", __assign({ className: "code-text" }, { children: code })), (0, jsx_runtime_1.jsx)(conditional_1.Conditional, __assign({ on: editable }, { children: (0, jsx_runtime_1.jsx)("span", __assign({ onClick: onCodeDelete, className: "code-delete-icon qa-code-delete-icon" }, { children: (0, jsx_runtime_1.jsx)("span", __assign({ className: "code-action-icon-inner code-delete" }, { children: (0, jsx_runtime_1.jsx)("a", __assign({ href: "#/delete-code", className: "code-delete-link" }, { children: (0, jsx_runtime_1.jsx)(svg_icons_1["default"], { svgIconName: "BiomeCancelCircle", svgIconSize: "12" }) })) })) })) }))] })))] })));
};
exports.MedicalCodeChip = MedicalCodeChip;
exports.MedicalCodeChip.defaultProps = {
    classNames: []
};
//# sourceMappingURL=medicalcode-chip.js.map